<div class="border-div property-more-details-box">
    <h3 class="mainhead">
        <span class="text">Details</span></h3>
        <div class="table-responsive">
            <table class="table basictable row-border hover">
                <thead>
                    <tr>
                        <th>Form Field</th>
                        <th>Previous Value</th>
                        <th>Current Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let history of historyFields">
                        <td>{{history.Name}}</td>
                        <td *ngIf="history.DataType != 'Datetime' && history.DataType != 'Dropdown' && history.DataType != 'Boolean' && history.DataType != 'Integer'">
                            {{history.Value ? history.Prefix :''}} {{history.Value ? history.Value : '-'}} {{history.Value ? history.Suffix :''}}
                        </td>
                        <td *ngIf="history.DataType == 'Datetime'">
                          {{history.Value ? history.Prefix : ''}} {{history.Value ?(_validationService.convertUTCDateToLocalDate1(history.Value) | date: 'MM/dd/yyyy' ) : '-'}} {{history.Value ? history.Suffix : ''}}
                        </td>
                        <td *ngIf="history.DataType == 'Integer'">
                            {{history.Value ? history.Prefix : ''}} {{history.Value ? (history.Value | number:0) : '-'}} {{history.Value ? history.Suffix : ''}}
                        </td>
                        <td *ngIf="history.DataType == 'Boolean'">
                            <label class="custom-checkbox margin-right-15" for="checkbox16">
                                <input *ngIf="history.Value == 'True'" type="checkbox" checked disabled />
                                <input *ngIf="history.Value == 'False'" type="checkbox" disabled />

                                <i></i>
                            </label>
                            <span *ngIf="history.Value != 'False' && history.Value != 'True'">-</span>
                        </td>
                        <td *ngIf="history.DataType == 'Dropdown'">
                            {{history.DropdownValue ? history.Prefix : ''}} {{history.DropdownValue ? history.DropdownValue : '-'}} {{history.DropdownValue ? history.Suffix : ''}}
                        </td>
                        <td *ngIf="history.DataType == 'Datetime'">
                          {{history.NewValue ? history.Prefix : ''}} {{history.NewValue ? (_validationService.convertUTCDateToLocalDate1(history.NewValue) | date: 'MM/dd/yyyy' ) : '-'}} {{history.NewValue ? history.Suffix : ''}}
                        </td>
                        <td *ngIf="history.DataType == 'Dropdown'">
                            {{history.NewDropdownValue ? history.Prefix : ''}} {{history.NewDropdownValue ? history.NewDropdownValue : '-'}} {{history.NewDropdownValue ? history.Suffix : ''}}
                        </td>
                        <td *ngIf="history.DataType != 'Dropdown' && history.DataType != 'Datetime' && history.DataType != 'Boolean' && history.DataType != 'Integer'">
                            {{history.NewValue ? history.Prefix : ''}} {{history.NewValue ? history.NewValue : '-'}} {{history.NewValue ? history.Suffix : ''}}
                        </td>
                        <td *ngIf="history.DataType == 'Integer'">
                            {{history.NewValue ? history.Prefix : ''}} {{history.NewValue ? (history.NewValue | number:0) : '-'}} {{history.NewValue ? history.Suffix : ''}}
                        </td>
                        <td *ngIf="history.DataType == 'Boolean'">
                            <label class="custom-checkbox margin-right-15" for="checkbox16">

                                <input *ngIf="history.NewValue == 'True'" type="checkbox" checked disabled />
                                <input *ngIf="history.NewValue != 'True'" type="checkbox" disabled />
                                <i></i>
                            </label>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
